.spinner {
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 50%;
	border: 1px solid currentColor;
	animation:
		l20-1 1s infinite linear alternate,
		l20-2 2s infinite linear;
}

@keyframes l20-1 {
	0% {
		clip-path: polygon(50% 50%, 0 0, 50% 0%, 50% 0%, 50% 0%, 50% 0%, 50% 0%);
	}

	12.5% {
		clip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 0%, 100% 0%, 100% 0%);
	}

	25% {
		clip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 100%, 100% 100%, 100% 100%);
	}

	50% {
		clip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 100%, 50% 100%, 0% 100%);
	}

	62.5% {
		clip-path: polygon(50% 50%, 100% 0, 100% 0%, 100% 0%, 100% 100%, 50% 100%, 0% 100%);
	}

	75% {
		clip-path: polygon(50% 50%, 100% 100%, 100% 100%, 100% 100%, 100% 100%, 50% 100%, 0% 100%);
	}

	100% {
		clip-path: polygon(50% 50%, 50% 100%, 50% 100%, 50% 100%, 50% 100%, 50% 100%, 0% 100%);
	}
}

@keyframes l20-2 {
	0% {
		transform: scaleY(1) rotate(0deg);
	}

	49.99% {
		transform: scaleY(1) rotate(135deg);
	}

	50% {
		transform: scaleY(-1) rotate(0deg);
	}

	100% {
		transform: scaleY(-1) rotate(-135deg);
	}
}
